import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import RightNav from './RightNav';
import { useLocation } from 'react-router-dom';

const StyledBurger = styled.div`
  width: 2rem;
  height: 2rem;
  position: fixed;
  right: 20px;
  z-index: 20;
  display: none; 

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
    z-index: 9999999;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open  , pathname}) => pathname === '/' ? open ? '#ccc' : '#fff' :'#000'};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    &:nth-child(2) {
      transform: ${({ open }) => open ? 'translateX(100%)' : 'translateX(0)'};
      opacity: ${({ open }) => open ? 0 : 1};
    }

    &:nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

const Burger = () => {
  const [open, setOpen] = useState(false)

  const location = useLocation();

  return (
    <>
      <StyledBurger open={open} onClick={() => setOpen(!open)} pathname={location.pathname}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <RightNav open={open} />
    </>
  )
}

export default Burger